import { Box, Grid2, Stack, Typography } from '@mui/material';

import { ColorPicker } from 'src/components/NodeSaleForm/ColorPicker';
import { colors } from 'src/global/styles/colors';
import { TProjectTheme } from 'src/global/types/theme.type';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { FontSelect } from './FontSelect';
import { FontWeightSelect } from './FontWeightSelect';

interface TextCustomizationGroupProps {
  groupBox: React.ReactNode;
  textKey: keyof TProjectTheme['text'];
  title: string;
}

export const TextCustomizationGroup = (props: TextCustomizationGroupProps) => {
  const { theme, updateTheme } = useTheme();
  const { groupBox, title, textKey } = props;

  return (
    <Box padding={3} borderBottom={`1px solid ${colors.neutral015}`}>
      <Typography color='white' variant='h6' fontSize={'16px'} fontWeight={500} lineHeight={'20px'} marginBottom={2}>
        {title}
      </Typography>
      <Stack direction={'row'} spacing={2} justifyContent={'space-between'}>
        {groupBox}
        <Box width={'-webkit-fill-available'}>
          <Grid2 container spacing={1} marginBottom={1}>
            <Grid2 size={6}>
              <FontSelect
                value={theme.text[textKey].fontFamily}
                onChange={e => {
                  updateTheme({
                    ...theme,
                    text: {
                      ...theme.text,
                      [textKey]: {
                        ...theme.text[textKey],
                        fontFamily: e.target.value,
                      },
                    },
                  });
                }}
              />
            </Grid2>
            <Grid2 size={6}>
              <FontWeightSelect
                value={theme.text[textKey].fontWeight}
                onChange={e => {
                  updateTheme({
                    ...theme,
                    text: {
                      ...theme.text,
                      [textKey]: {
                        ...theme.text[textKey],
                        fontWeight: Number(e.target.value),
                      },
                    },
                  });
                }}
              />
            </Grid2>
          </Grid2>
          <ColorPicker
            color={theme.text[textKey].color}
            onColorChange={color => {
              updateTheme({
                ...theme,
                text: {
                  ...theme.text,
                  [textKey]: {
                    ...theme.text[textKey],
                    color: color,
                  },
                },
              });
            }}
            opacity={theme.text[textKey].opacity}
            onOpacityChange={opacity => {
              updateTheme({
                ...theme,
                text: {
                  ...theme.text,
                  [textKey]: {
                    ...theme.text[textKey],
                    opacity: opacity / 100,
                  },
                },
              });
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};
